import React, { useRef } from 'react';
import { arrayOf, object } from 'prop-types';
import { reportEvent } from '../../../utils/reports/reviewsList';
import useObserver from '../../shared/hooks/useObserver';
import ReviewItem from './ReviewItem';
import './styles.scss';

const ReviewsList = ({ reviews = [] }) => {
    const prioritiesByCountry = !!reviews.find((review) => review.changed_position);
    const reviewsListRef = useRef(null);
    useObserver({
        observableRef: reviewsListRef,
        onObserve: () =>
            reportEvent({
                'Prioritised By Country': prioritiesByCountry,
            }),
    });

    return (
        <ul className="review-list" ref={reviewsListRef}>
            {reviews.map((review, index) => (
                <ReviewItem key={review.id} review={review} position={index + 1} />
            ))}
        </ul>
    );
};

ReviewsList.propTypes = {
    reviews: arrayOf(object),
};

export default ReviewsList;
